import landingBg from "./images/login-image.png";
import urbcLogoWhite from "./images/urbc-logo-white.png";
import urbcLogo from "./images/urbc-logo.png";
import noRecord from "./images/noRecord.svg";

export const images = {
   landingBg,
   urbcLogo,
   urbcLogoWhite,
   noRecord,
};
